"use client";
import { jsxs as _, Fragment as m, jsx as r } from "react/jsx-runtime";
import { useSlottedTemplate as p } from "../../hooks/use-slotted-template/use-slotted-template.js";
import i from "clsx";
import { Slot as d } from "@radix-ui/react-slot";
import '../../assets/tab.css';const l = {
  "tab-control": "_tab-control_2skcc_1",
  "tab-control--active": "_tab-control--active_2skcc_39",
  "tab-control__label": "_tab-control__label_2skcc_47"
}, u = ({
  icon: t,
  children: o
}) => /* @__PURE__ */ _(m, { children: [
  t && /* @__PURE__ */ r("span", { children: t }),
  /* @__PURE__ */ r("span", { className: l["tab-control__label"], children: o })
] }), k = ({
  children: t,
  className: o,
  asChild: c,
  active: e,
  icon: a,
  ...n
}) => {
  const s = c ? d : "button", b = p({
    children: t,
    asChild: c,
    template: u,
    props: { icon: a }
  });
  return /* @__PURE__ */ r(
    s,
    {
      className: i(o, {
        [l["tab-control"]]: !0,
        [l["tab-control--active"]]: e
      }),
      "aria-current": e ? "page" : void 0,
      role: c ? "tab" : void 0,
      ...n,
      children: b
    }
  );
};
export {
  u as Child,
  k as Tab
};
